import { CoreIcon } from '../core-icon';
import coinCircleGraySVG from '../../assets/icons/coin-circle-gray.svg';
import type { IconProps } from '../core-icon';

export const CoinCircleGrayIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={coinCircleGraySVG} {...props} />;
};
